var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.33251 10.3767L0.386472 2.5338C0.139044 2.25475 0 1.87738 0 1.48395C0 1.09052 0.139044 0.713058 0.386472 0.434011C0.507815 0.296377 0.652199 0.18708 0.811493 0.112503C0.970787 0.0379238 1.14163 -0.000465393 1.31427 -0.000465393C1.4869 -0.000465393 1.65807 0.0379238 1.81736 0.112503C1.97666 0.18708 2.12104 0.296377 2.24239 0.434011L10.1185 9.32532C10.3659 9.60436 10.505 9.98183 10.505 10.3753C10.505 10.7687 10.3659 11.1461 10.1185 11.4252L2.24239 20.3165C2.12104 20.4541 1.97666 20.5634 1.81736 20.638C1.65807 20.7126 1.4869 20.751 1.31427 20.751C1.14163 20.751 0.970787 20.7126 0.811493 20.638C0.652199 20.5634 0.507815 20.4541 0.386472 20.3165C0.139044 20.0375 0 19.66 0 19.2666C0 18.8731 0.139044 18.4958 0.386472 18.2167L7.33251 10.3767Z",
  fill: "#3A36DB"
});

function SvgGt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 21,
    viewBox: "0 0 11 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.0dc565456b1ca8a90e5f4dd1a850a682.svg";
export { ForwardRef as ReactComponent };